"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkedDefaultProps = exports.checkedPropTypes = exports.useChecked = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var useChecked = function useChecked(props) {
  var checked = props.checked,
      defaultChecked = props.defaultChecked,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(defaultChecked),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      checkedState = _useState2[0],
      setCheckedState = _useState2[1];

  var handleChange = (0, _react.useCallback)(function (evt) {
    setCheckedState(evt.target.checked);
    if (onChange) onChange(evt);
  }, [onChange]);
  return {
    checked: checked !== undefined ? checked : checkedState,
    onChange: handleChange
  };
};

exports.useChecked = useChecked;
var checkedPropTypes = {
  checked: _propTypes.default.bool,
  defaultChecked: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
exports.checkedPropTypes = checkedPropTypes;
var checkedDefaultProps = {
  defaultChecked: false
};
exports.checkedDefaultProps = checkedDefaultProps;